import React, {useEffect, useState} from 'react';
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {placeService} from "../../../jwt/_services/hotel/placeService";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {Card, CardBody, CardTitle, Collapse} from "reactstrap";
import {LIST} from "../../../components/i18n/i18n";
import {GenericButton} from "../../../components/buttons/customButtons";
import {DragDropList} from "../../../components/draggableList/DragDropList";
import Pagination from "rc-pagination";
import RestaurantItem from "./_listItem";
import RestaurantControllerFilters from "./_filters";
import RestaurantControllerForm from "./_form";

const RestaurantControllerList = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, category, pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    const [categorizedItems, setCategorizedItems] = useState([]);

    useEffect( () => {
        if( !app.id || !udn.id || filter)
            return

        props.setFilter(path , {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                categoryCodes : category,
                udn : { id : udn.id }
            }
        });
    }, [ app, udn ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, placeService, pageIndex, 100, filter)
    }, [pageIndex, pageSize, filter ]);

    useEffect(() => {
        mapItemsToCategoryItems(listDomainObjects);
    }, [listDomainObjects]);

    const handleTableChange = (_page) => {
        let currentIndex = (_page - 1) * pageSize;
        props.setTableParams(path, pageSize, currentIndex, totalSize, currentIndex );
    };

    const mapItemsToCategoryItems = (_listItems) => {
        const groupedItems = [];

        for (const item of _listItems) {
            const category = groupedItems.find(c => c.id === item.category);

            if (!category) {
                groupedItems.push({
                    id: item.category,
                    name: item.categoryName,
                    isOpen: true,
                    items: [item],
                });
            } else {
                category.items.push(item);
            }
        }
        // sort by categoryName

        groupedItems.sort((a, b) => b?.name?.localeCompare(a?.name));

        groupedItems.map(group => group?.items?.sort((a, b) => a?.showOrder - b?.showOrder));

        setCategorizedItems( groupedItems );
    };

    const onExpandContract = (index) => {
        let updatedCategorizedItems = [...categorizedItems];
        updatedCategorizedItems[index].isOpen = !updatedCategorizedItems[index].isOpen;
        setCategorizedItems(updatedCategorizedItems);
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path);
        ModalFormContainer( RestaurantControllerForm, { path } )
    }

    const editItem = (data) => {
        props.setForm(path, true, false, false);
        props.setItem(path, data);

        ModalFormContainer(RestaurantControllerForm, { path, data, Form: RestaurantControllerForm })
    }

    const onReorder = (reorderProps) => {
        // Crear una copia de listDomainObjects para evitar mutaciones directas
        let updatedListDomainObjects = [...listDomainObjects];
        let dataRequest = {
            fbDataBase:  { id : app?.fbDataBase?.id },
            items: []
        }

        for (const reorderedItem of reorderProps.list) {
            // Validar si el ítem tiene un id (es decir, si existe en la base de datos)
            if (reorderedItem.id) {
                // Buscar el ítem en listDomainObjects
                let domainObject = updatedListDomainObjects.find(domainObject => domainObject.id === reorderedItem.id);

                if (domainObject && domainObject.showOrder !== reorderedItem.showOrder) {
                    dataRequest.items.push({
                        id: domainObject.id,
                        showOrder: reorderedItem.showOrder
                    })
                }

            }
        }

        genericIndexedActions.reorder(path, placeService, dataRequest)
    }

    const renderContent = (item, index) => {
        return (
            <RestaurantItem
                item={item}
                index={index}
                onEdit={editItem}
            />
        )
    }

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <CardBody className="">
            <RestaurantControllerFilters path={path}/>
            {
                props?.groupByCategory ?
                    <DragDropList
                        items={listDomainObjects}
                        renderContent={renderContent}
                        onReorder={onReorder}
                        orientationHV={'ruby-text-container'} // CSS class para orientar los elementos horizontalmente
                    />
                    :
                categorizedItems.map((categoryGroup, index) => {
                    return (< >
                            <div id={'category-group-header' + index} className={'category-gtoup-header'} >
                                <h1>{categoryGroup?.name}</h1>
                                <GenericButton style={'table'}
                                               toolTip={categoryGroup?.isOpen ? 'Contraer' : 'Expandir'}
                                               icon={categoryGroup?.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'}
                                               permission={'search'}
                                               onClick={_ => onExpandContract(index)} />
                            </div>
                            <div id={'category-group-items' + index} >
                                <Collapse isOpen={categoryGroup?.isOpen || false} >
                                    {
                                        categoryGroup?.items?.length > 0 &&
                                        <DragDropList
                                            items={categoryGroup?.items}
                                            renderContent={renderContent}
                                            onReorder={onReorder}
                                            orientationHV={'ruby-text-container'} // CSS class para orientar los elementos horizontalmente
                                        />
                                    }
                                </Collapse>

                            </div>
                        </>
                    )
                })

            }
            <Pagination
                total={totalSize}
                shape="rounded"
                current={pageIndex}
                onChange={handleTableChange}
                pageSize={pageSize}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(RestaurantControllerList)